import * as moment from 'moment-timezone';
import * as React from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import Button from 'reactstrap/lib/Button';
import ButtonGroup from 'reactstrap/lib/ButtonGroup';
import DataTable from 'src/Components/DataTable';
import { IDispatchList } from 'src/Interfaces/DispatchInterface';


interface IDispatchListTableProps {
    dispatchList: IDispatchList[] | undefined;
    showApprovalColumn: boolean[];
    history?: any;
    onApprove: (dispatchId: string) => void;
    onReject: (dispatchId: string) => void;
}

export class DispatchListTable extends React.Component {
    public props: IDispatchListTableProps;

    constructor(props: any) {
        super(props);
    }


    private approveDispatch = (dispatchId: string) => () => {
        this.props.onApprove(dispatchId);
    }

    private rejectDispatch = (dispatchId: string) => () => {
        this.props.onReject(dispatchId);
    }

    private handleEdit = (index: any) => {
        if (this.props.dispatchList) {
            this.props.history.push('/dispatches/' + this.props.dispatchList[index].id);
        }
    }
    private renderApprovalButtons = (dispatchItem: IDispatchList) => () => {
        switch (dispatchItem.dispatchStatus) {
            case 'Completed':
            case 'Confirmed':
            case 'Denied':
            case 'Approved':
            case 'Cancelled':
                return '';
        }

        if (dispatchItem.type === 'Transfer' 
            && (dispatchItem.destinationWellId === null || dispatchItem.destinationWellId === '')) {
            return '';
        }
        return <ButtonGroup>
        { dispatchItem.dispatchStatus !== 'Approved' && <Button type="button" color="success" onClick={this.approveDispatch(dispatchItem.id)}>Approve</Button> }
        { dispatchItem.dispatchStatus !== 'Rejected' && <Button type="button" color="danger" onClick={this.rejectDispatch(dispatchItem.id)}>Reject</Button>}
        </ButtonGroup>;
    }

    private renderDateSubmitted = (value: IDispatchList) => () => {
        return <Link to={'/dispatches/' + value.id}>{moment.unix(Number(value.createDate)).format("MMM DD YYYY - h:mm a")}</Link>;
    }

    private formatDataTable = () => {
        const headers = [
            'Source Well',
            'Dest Well',
            'Type',
            'Test Date',
            'Submitted By',
            'Date Submitted',
            'RTA',
            'Status',
            'Status Changed By',
            'Status Changed Date',
        ];

        if (this.props.showApprovalColumn.some(ac => ac)) {
            headers.push('Approve / Reject');
        }
        const rows: any = [];

        if (!this.props.dispatchList) {
            return {
                headers,
                rows,
            };
        }
        this.props.dispatchList.forEach((value, index) => {
            const tempRow: any = [
                {
                    content: value.sourceWell ? value.sourceWell.wellName : value.destinationWell.warehouseName,
                },
                {
                    content: value.destinationWell ? value.destinationWell.wellName : value.sourceWell.warehouseName,
                },
                {
                    content: value.type
                },
                {
                    content: value.submittedWellTest ? moment.unix(Number(value.submittedWellTest.testDate)).format("MMM DD YYYY - h:mm a") : 'None',
                    sortItem: value.submittedWellTest ? value.submittedWellTest.testDate : 0,
                },
                {
                    content: value.createBy,
                },
                {
                    content: this.renderDateSubmitted(value),
                    sortItem: value.createDate,
                    type: 'render',
                },
                {
                    content: moment.unix(Number(value.requestedArrival)).format("MMM DD YYYY - h:mm a"),
                    sortItem: value.requestedArrival
                },
                {
                    content: value.dispatchStatus
                },
                {
                    content: value.statusChangeBy
                },
                {
                    content: moment.unix(Number(value.statusChangeDate)).format("MMM DD YYYY - h:mm a"),
                    sortItem: value.statusChangeDate
                },
            ];

            if (this.props.showApprovalColumn[index]) {
                tempRow.push({
                    content: this.renderApprovalButtons(value),
                    type: 'render',
                });
            }
            rows.push(tempRow);
        });

        return {
            headers,
            rows,
        };


    }

    public render() {
        if (!this.props.dispatchList) {
            return '';
        }

        return <DataTable
                    list={this.formatDataTable()}
                    onEdit={this.handleEdit}
                />;
    }
}

export default withRouter(DispatchListTable);


// WEBPACK FOOTER //
// ./src/Components/Main/Dispatch/DispatchListTable/DispatchListTable.tsx